module.exports = __webpack_public_path__ + "img/navbar-logo5.23608537.png";